import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import {
  foundingMemberCreatorPath,
  foundingMemberCreatorPausePath,
  foundingMemberCreatorStagePath,
} from "@travily/routes";
import type FoundingMemberCreatorIndividualConnect from "@travily/types/pages/FoundingMemberCreatorIndividualConnect";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { ConnectStepView } from "./show.view";

type FormData = {
  individual_profile: {
    socials: string;
  };
};

const FIELD = "individual_profile.socials";

const ConnectStep = ({ stage_index, stage_order, individual_profile }: FoundingMemberCreatorIndividualConnect) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("individual", stage),
        entryUrl: foundingMemberCreatorPath(),
        pauseUrl: foundingMemberCreatorPausePath(),
      },
      stageName: "connect",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: { individual_profile: { socials: individual_profile.socials ?? "" } },
    });

  const error = fieldError(FIELD);

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.individual.connect.show.meta_title")}>
        <meta
          name="description"
          content={t("web.founding_members.creator.steps.individual.connect.show.meta_description")}
        />
      </Head>
      <ConnectStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        socials={form.data.individual_profile.socials}
        error={error}
        onSocialsChange={(value) => {
          form.setData(FIELD, value);
          validate(FIELD);
        }}
      />
    </>
  );
};

export default ConnectStep;
